export default {
  "title": "FreeDive Ai",
  "heroHeadline": "Treine todos os dias e melhore suas habilidades de apneia!",
  "heroSubheadline": "O melhor aplicativo de treinamento de apneia com IA para apneístas, pescadores submarinos e sereias.",
  "featuresHeader": "Por que escolher o FreeDive Ai?",
  "featuresSubtitle": "Tudo o que você precisa para mergulhar mais fundo, prender a respiração por mais tempo e se manter seguro.",
  "feature1Title": "Treinamento de Apneia com IA",
  "feature1Desc": "Tabelas personalizadas de CO2 e O2 geradas pela IA com base em seus recordes pessoais para aumentar seus tempos de apneia com segurança.",
  "feature2Title": "Diário de Mergulho Inteligente",
  "feature2Desc": "Registre suas sessões de apneia e pesca submarina. Acompanhe profundidades, tempos, frequência cardíaca e SpO2 em um só lugar.",
  "feature3Title": "Competições e Licenças",
  "feature3Desc": "Acompanhe suas licenças de apneia e mantenha-se atualizado com competições e eventos globais.",
  "screenshotsTitle": "Capturas de tela do aplicativo",
  "copyright": "© DomiLabs. All rights reserved."
};
